import JobStatusHiredModal from './JobStatusHiredModal'
export default JobStatusHiredModal
